/* ==========================================================================
   Plant Quiz — Scoring engine, Klaviyo integration, Cart API, Gift mode
   Rebuild: tag-parsed Liquid JSON blob, filter-first scoring
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------
     CONSTANTS
  --------------------------------------------------------------- */
  var STEPS = ['landing', 'q1', 'q2', 'q3', 'q4', 'email', 'loading', 'results'];
  var Q_STEPS = ['q1', 'q2', 'q3', 'q4'];
  var TRANSITION_MS = 200;

  /* Light mapping: user-facing option values → JSON blob "light" value
     Store only has two light tags: "Light: Happy in Bright Light" (bright)
     and "Light: Happy in Low Light" (low). No medium tag exists. */
  var LIGHT_MAP = {
    bright_direct: 'bright',
    bright_indirect: 'bright',
    medium: 'low',
    low: 'low'
  };

  /* Adjacent light levels for progressive fallback */
  var ADJACENT_LIGHT = {
    bright: ['low'],
    low: ['bright']
  };

  /* Gift mode copy variants */
  var GIFT_COPY = {
    q1_title: 'How much light does their space get?',
    q2_title: 'Do they have pets?',
    q3_title: 'How experienced are they with plants?',
    q4_title: 'What size plant are you looking for?',
    email_heading: 'Where should we send the gift recommendations?',
    results_heading: 'Perfect gifts for a plant lover'
  };

  /* Normal copy (read from DOM on init) */
  var NORMAL_COPY = {};

  /* ---------------------------------------------------------------
     STATE
  --------------------------------------------------------------- */
  var state = {
    step: 'landing',
    answers: {},
    giftMode: false,
    email: '',
    consent: false,
    results: [],
    emailCaptured: false
  };

  /* ---------------------------------------------------------------
     DOM REFS
  --------------------------------------------------------------- */
  var root, plants;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------
     INIT
  --------------------------------------------------------------- */
  function init() {
    root = document.querySelector('[data-pq-root]');
    if (!root) return;

    /* Parse plant data */
    var dataEl = document.getElementById('quiz-plant-data');
    if (dataEl) {
      try { plants = JSON.parse(dataEl.textContent); }
      catch (e) { plants = []; console.error('PQ: bad plant JSON', e); }
    } else {
      plants = [];
    }

    /* Cache normal copy for gift toggle */
    var q1Title = $('[data-pq-q1-title]');
    var q2Title = $('[data-pq-q2-title]');
    var q3Title = $('[data-pq-q3-title]');
    var q4Title = $('[data-pq-q4-title]');
    var emailH = $('[data-pq-email-title]');
    var resultsH = $('[data-pq-results-title]');
    if (q1Title) NORMAL_COPY.q1_title = q1Title.textContent;
    if (q2Title) NORMAL_COPY.q2_title = q2Title.textContent;
    if (q3Title) NORMAL_COPY.q3_title = q3Title.textContent;
    if (q4Title) NORMAL_COPY.q4_title = q4Title.textContent;
    if (emailH) NORMAL_COPY.email_heading = emailH.textContent;
    if (resultsH) NORMAL_COPY.results_heading = resultsH.textContent;

    bindEvents();
    setupAbandonRecovery();
  }

  /* ---------------------------------------------------------------
     EVENT BINDING
  --------------------------------------------------------------- */
  function bindEvents() {
    /* Start quiz */
    var startBtn = $('[data-pq-start]');
    if (startBtn) startBtn.addEventListener('click', function () {
      state.giftMode = !!($('[data-pq-gift-toggle]') || {}).checked;
      root.setAttribute('data-pq-gift-mode', state.giftMode ? 'true' : 'false');
      if (state.giftMode) applyGiftCopy();
      goTo('q1');
      track('quiz_started', { gift_mode: state.giftMode });
    });

    /* Gift toggle */
    var giftInput = $('[data-pq-gift-toggle]');
    if (giftInput) giftInput.addEventListener('change', function () {
      state.giftMode = this.checked;
    });

    /* Option buttons (Q1-Q4) */
    var advancing = false;
    $$('[data-pq-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (advancing) return;
        var group = this.closest('[data-pq-options]');
        var key = group.getAttribute('data-pq-options');
        var value = this.getAttribute('data-value');

        /* Update UI */
        $$('[data-pq-option]', group).forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');

        /* Store answer */
        state.answers[key] = value;
        track('quiz_answer', { question: key, answer: value, gift_mode: state.giftMode });

        /* Auto-advance after brief delay (debounced) */
        advancing = true;
        var stepIndex = Q_STEPS.indexOf(key);
        if (stepIndex < Q_STEPS.length - 1) {
          setTimeout(function () { advancing = false; goTo(Q_STEPS[stepIndex + 1]); }, TRANSITION_MS);
        } else {
          setTimeout(function () { advancing = false; goTo('email'); }, TRANSITION_MS);
        }
      });
    });

    /* Light helper toggle */
    var helperToggle = $('[data-pq-light-helper-toggle]');
    var helperContent = $('[data-pq-light-helper-content]');
    if (helperToggle && helperContent) {
      helperToggle.addEventListener('click', function () {
        var expanded = helperContent.style.display !== 'none';
        helperContent.style.display = expanded ? 'none' : 'block';
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (!expanded) track('quiz_light_helper_opened');
      });
    }

    /* Collapse light helper when selecting a light option */
    $$('[data-pq-options="q1"] [data-pq-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (helperContent) helperContent.style.display = 'none';
        if (helperToggle) helperToggle.setAttribute('aria-expanded', 'false');
      });
    });

    /* Back buttons — navigate to previous step */
    $$('[data-pq-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.getAttribute('data-pq-back');
        if (!target) {
          /* Generic back: go to previous step in sequence */
          var curIndex = STEPS.indexOf(state.step);
          target = curIndex > 0 ? STEPS[curIndex - 1] : 'landing';
        }
        goTo(target);
        /* Reset light helper on back to q1 */
        if (target === 'q1' && helperContent) {
          helperContent.style.display = 'none';
          if (helperToggle) helperToggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    /* Email submit */
    var emailSubmitBtn = $('[data-pq-submit]');
    if (emailSubmitBtn) emailSubmitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var input = $('[data-pq-email-input]');
      var consentBox = $('[data-pq-consent]');
      var errorEl = $('[data-pq-email-error]');
      if (!input || !input.value.trim()) return;

      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorEl) errorEl.textContent = 'Please enter a valid email address.';
        input.focus();
        return;
      }
      if (errorEl) errorEl.textContent = '';

      state.email = email;
      state.consent = consentBox ? consentBox.checked : false;
      state.emailCaptured = true;

      klaviyoIdentify(state.email, state.consent);
      klaviyoTrack('quiz_email_captured', buildKlaviyoProps());
      track('quiz_email_captured', { gift_mode: state.giftMode });

      goTo('loading');
      setTimeout(function () {
        runScoring();
        renderResults();
        goTo('results');
        klaviyoTrack('quiz_results_viewed', buildKlaviyoProps());
        track('quiz_results_viewed', { result_count: state.results.length, gift_mode: state.giftMode });
      }, 1200);
    });

    /* Skip email */
    var skipBtn = $('[data-pq-skip-email]');
    if (skipBtn) skipBtn.addEventListener('click', function () {
      goTo('loading');
      setTimeout(function () {
        runScoring();
        renderResults();
        goTo('results');
        track('quiz_email_skipped', { gift_mode: state.giftMode });
      }, 1200);
    });

    /* Bundle CTA */
    var bundleBtn = $('[data-pq-bundle-btn]');
    if (bundleBtn) bundleBtn.addEventListener('click', handleBundleAdd);

    /* Retake */
    var retakeBtn = $('[data-pq-restart]');
    if (retakeBtn) retakeBtn.addEventListener('click', function () {
      state = {
        step: 'landing',
        answers: {},
        giftMode: false,
        email: '',
        consent: false,
        results: [],
        emailCaptured: false
      };
      /* Reset gift toggle */
      var giftInput = $('[data-pq-gift-toggle]');
      if (giftInput) giftInput.checked = false;
      root.setAttribute('data-pq-gift-mode', 'false');
      resetGiftCopy();
      /* Reset selected options */
      $$('.pq-option.is-selected').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      });
      goTo('landing');
      track('quiz_retake');
    });
  }

  /* ---------------------------------------------------------------
     NAVIGATION
  --------------------------------------------------------------- */
  function goTo(step) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    state.step = step;

    $$('[data-pq-step]').forEach(function (el) {
      var isTarget = el.getAttribute('data-pq-step') === step;
      if (reducedMotion) {
        el.classList.toggle('is-active', isTarget);
      } else {
        if (isTarget) {
          el.classList.add('is-active');
        } else {
          el.classList.remove('is-active');
        }
      }
    });

    /* Progress bar */
    var progressEl = $('[data-pq-progress]');
    var qIndex = Q_STEPS.indexOf(step);
    if (qIndex >= 0 && progressEl) {
      progressEl.style.display = '';
      var pct = ((qIndex + 1) / Q_STEPS.length * 100);
      var fill = $('[data-pq-progress-fill]');
      var text = $('[data-pq-progress-text]');
      if (fill) fill.style.width = pct + '%';
      if (text) text.textContent = 'Step ' + (qIndex + 1) + ' of ' + Q_STEPS.length;

      /* Gift pill */
      var pill = $('[data-pq-gift-pill]');
      if (pill) pill.style.display = state.giftMode ? '' : 'none';
    } else if (progressEl && step === 'email') {
      progressEl.style.display = '';
      var fill = $('[data-pq-progress-fill]');
      if (fill) fill.style.width = '100%';
      var text = $('[data-pq-progress-text]');
      if (text) text.textContent = 'Almost there!';
    } else if (progressEl) {
      progressEl.style.display = 'none';
    }

    /* Scroll to top of quiz */
    if (root.getBoundingClientRect().top < 0) {
      root.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }
  }

  /* ---------------------------------------------------------------
     SCORING ENGINE
  --------------------------------------------------------------- */
  function scorePlant(p, light, petSafe, experience, sizePreference) {
    var score = 0;
    var careMatch = 'none';
    if (experience === 'beginner' && p.care_difficulty === 'beginner') { score += 2; careMatch = 'exact'; }
    else if (experience === 'beginner' && p.care_difficulty === 'intermediate') { score += 1; careMatch = 'close'; }
    else if (experience === 'intermediate' && p.care_difficulty === 'intermediate') { score += 2; careMatch = 'exact'; }
    else if (experience === 'intermediate' && p.care_difficulty === 'beginner') { score += 1; careMatch = 'close'; }
    else if (experience === 'advanced') { careMatch = 'any'; }
    var sizeMatch = !!(p.variants && p.variants.some(function (v) { return v.bucket === sizePreference; }));
    if (sizeMatch) score += 1;
    p._score = score;
    p._match = {
      light: p.light === light ? 'exact' : 'relaxed',
      petSafe: petSafe ? (p.pet_safe ? 'yes' : 'no') : 'not_required',
      care: careMatch,
      size: sizeMatch
    };
  }

  function runScoring() {
    var light = LIGHT_MAP[state.answers.q1] || 'medium';
    var petSafe = state.answers.q2 === 'true';
    var experience = state.answers.q3 || 'beginner';
    var sizePreference = state.answers.q4 || 'medium';

    /* Step 1: Hard filter — light + pet safety (clone to avoid mutating shared array) */
    var filtered = plants.filter(function (p) {
      if (petSafe && !p.pet_safe) return false;
      return p.light === light;
    }).map(function (p) { return Object.assign({}, p); });

    /* Step 2: Progressive fallback if no results */
    if (filtered.length === 0) {
      var adjacent = ADJACENT_LIGHT[light] || [];
      for (var i = 0; i < adjacent.length && filtered.length === 0; i++) {
        filtered = plants.filter(function (p) {
          if (petSafe && !p.pet_safe) return false;
          return p.light === adjacent[i];
        }).map(function (p) { return Object.assign({}, p); });
      }
    }

    /* Step 3: Soft score — care difficulty + size preference match */
    filtered.forEach(function (p) {
      scorePlant(p, light, petSafe, experience, sizePreference);
    });

    /* Sort by score descending, take top 3 */
    filtered.sort(function (a, b) { return b._score - a._score; });
    state.results = filtered.slice(0, 3);
  }

  /* ---------------------------------------------------------------
     RENDER RESULTS
  --------------------------------------------------------------- */
  function renderResults() {
    var container = $('[data-pq-results-list]');
    if (!container) return;
    container.innerHTML = '';

    var ctaLabel = root.getAttribute('data-pq-cta-label') || 'View plant';

    if (state.results.length === 0) {
      renderEmptyState(container);
      return;
    }

    var answers = state.answers;
    var isGift = state.giftMode;

    var CARE_TAG_LABELS = { beginner: 'Easy Care', intermediate: 'Low Fuss', advanced: 'Expert Care' };
    var LIGHT_TAG_LABELS = { bright: 'Sun Loving', low: 'Shade Tolerant' };
    var sizePreference = state.answers.q4 || 'medium';

    /* Mark all results as selected initially */
    state.results.forEach(function (p) { p._selected = true; });

    state.results.forEach(function (plant, i) {
      /* Plus divider between cards */
      if (i > 0) {
        var plus = document.createElement('div');
        plus.className = 'pq-fbt__plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.innerHTML = '<span>+</span>';
        container.appendChild(plus);
      }

      var card = document.createElement('div');
      card.className = 'pq-fbt__card pq-fbt__card--selected';
      card.setAttribute('data-pq-result-card', '');
      card.setAttribute('data-pq-fbt-index', i);

      var botanicalName = plant.title;
      var commonName = plant.common_name || '';

      /* Pick default variant: prefer quiz size answer, else first */
      var defaultVariant = null;
      if (plant.variants && plant.variants.length) {
        for (var v = 0; v < plant.variants.length; v++) {
          if (plant.variants[v].bucket === sizePreference) { defaultVariant = plant.variants[v]; break; }
        }
        if (!defaultVariant) defaultVariant = plant.variants[0];
        plant._selectedVariant = defaultVariant;
      }

      /* Size pills (clickable variant selectors) */
      var sizePills = '';
      if (plant.variants && plant.variants.length >= 1) {
        sizePills = '<div class="pq-fbt__sizes">';
        plant.variants.forEach(function (vr) {
          var isActive = defaultVariant && vr.id === defaultVariant.id;
          sizePills += '<button type="button" class="pq-fbt__size-pill' + (isActive ? ' is-active' : '') + '" data-pq-variant-id="' + vr.id + '" data-pq-card-index="' + i + '">' + escapeHtml(vr.label) + '</button>';
        });
        sizePills += '</div>';
      }

      /* Trait tags */
      var traits = '<div class="pq-fbt__traits">';
      if (plant.pet_safe) traits += '<span class="pq-fbt__trait">Pet & Child Safe</span>';
      if (LIGHT_TAG_LABELS[plant.light]) traits += '<span class="pq-fbt__trait">' + LIGHT_TAG_LABELS[plant.light] + '</span>';
      if (CARE_TAG_LABELS[plant.care_difficulty]) traits += '<span class="pq-fbt__trait">' + CARE_TAG_LABELS[plant.care_difficulty] + '</span>';
      traits += '</div>';

      /* Price — use selected variant's price */
      var variantPrice = defaultVariant ? defaultVariant.price : plant.price;
      var variantCompare = defaultVariant ? defaultVariant.compare_price : plant.compare_price;
      var priceHtml = buildPriceHtml(variantPrice, variantCompare);

      /* Sale badge */
      var saleBadge = plant.on_sale ? '<span class="pq-fbt__badge">Sale</span>' : '';

      /* Checkbox */
      var checkbox = '<div class="pq-fbt__check">' +
        '<label class="pq-fbt__check-label">' +
          '<input class="pq-fbt__check-input" type="checkbox" checked data-pq-fbt-check="' + i + '">' +
          '<span class="pq-fbt__check-box">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
          '</span>' +
        '</label>' +
      '</div>';

      /* Match pills */
      var matchPills = buildMatchBreakdown(plant);

      card.innerHTML =
        checkbox +
        '<div class="pq-fbt__image-wrap">' +
          saleBadge +
          '<img src="' + escapeAttr(defaultVariant ? defaultVariant.image : plant.image) + '" alt="' + escapeAttr(commonName || botanicalName) + '" loading="lazy" width="400" height="400" data-pq-card-img="' + i + '">' +
        '</div>' +
        '<div class="pq-fbt__info">' +
          (commonName ? '<p class="pq-fbt__common">' + escapeHtml(commonName) + '</p>' : '') +
          '<h3 class="pq-fbt__name">' + escapeHtml(botanicalName) + '</h3>' +
          sizePills +
          traits +
          matchPills +
          priceHtml +
        '</div>';

      container.appendChild(card);
    });

    /* Summary bar */
    var summaryEl = document.createElement('div');
    summaryEl.className = 'pq-fbt__summary';
    summaryEl.setAttribute('data-pq-fbt-summary', '');
    summaryEl.innerHTML =
      '<div class="pq-fbt__summary-pricing">' +
        '<span class="pq-fbt__summary-label">Total price:</span>' +
        '<div class="pq-fbt__summary-values">' +
          '<span class="pq-fbt__summary-total" data-pq-fbt-total></span>' +
          '<span class="pq-fbt__summary-savings" data-pq-fbt-savings style="display:none"></span>' +
        '</div>' +
      '</div>' +
      '<div class="pq-fbt__summary-cta">' +
        '<button class="pq-fbt__add-btn" data-pq-bundle-btn type="button">Add all to basket</button>' +
        '<p class="pq-fbt__status" data-pq-bundle-status></p>' +
      '</div>';
    container.appendChild(summaryEl);

    /* Wire up checkbox toggles */
    var checkboxes = container.querySelectorAll('[data-pq-fbt-check]');
    for (var c = 0; c < checkboxes.length; c++) {
      checkboxes[c].addEventListener('change', function () {
        var idx = parseInt(this.getAttribute('data-pq-fbt-check'), 10);
        state.results[idx]._selected = this.checked;
        var card = this.closest('[data-pq-fbt-index]');
        if (card) {
          card.className = this.checked ? 'pq-fbt__card pq-fbt__card--selected' : 'pq-fbt__card pq-fbt__card--deselected';
        }
        updateFbtSummary();
      });
    }

    /* Card click toggles selection (except variant pills and checkbox label) */
    var cards = container.querySelectorAll('[data-pq-fbt-index]');
    for (var ci = 0; ci < cards.length; ci++) {
      cards[ci].addEventListener('click', function (e) {
        /* Don't toggle if clicking a variant pill or the checkbox itself */
        if (e.target.closest('[data-pq-variant-id]') || e.target.closest('.pq-fbt__check')) return;
        var idx = parseInt(this.getAttribute('data-pq-fbt-index'), 10);
        var cb = this.querySelector('[data-pq-fbt-check]');
        if (cb) {
          cb.checked = !cb.checked;
          cb.dispatchEvent(new Event('change'));
        }
      });
      cards[ci].style.cursor = 'pointer';
    }

    /* Wire up variant size pill clicks */
    var variantBtns = container.querySelectorAll('[data-pq-variant-id]');
    for (var vb = 0; vb < variantBtns.length; vb++) {
      variantBtns[vb].addEventListener('click', function () {
        var cardIdx = parseInt(this.getAttribute('data-pq-card-index'), 10);
        var variantId = parseInt(this.getAttribute('data-pq-variant-id'), 10);
        var plant = state.results[cardIdx];
        if (!plant || !plant.variants) return;

        /* Find variant */
        var variant = null;
        for (var vi = 0; vi < plant.variants.length; vi++) {
          if (plant.variants[vi].id === variantId) { variant = plant.variants[vi]; break; }
        }
        if (!variant) return;

        /* Update selected variant */
        plant._selectedVariant = variant;

        /* Update active pill state */
        var card = this.closest('[data-pq-fbt-index]');
        if (card) {
          var pills = card.querySelectorAll('[data-pq-variant-id]');
          for (var pi = 0; pi < pills.length; pi++) {
            pills[pi].classList.toggle('is-active', pills[pi] === this);
          }

          /* Update image */
          var img = card.querySelector('[data-pq-card-img]');
          if (img && variant.image) img.src = variant.image;

          /* Update price */
          var priceWrap = card.querySelector('.pq-fbt__price');
          if (priceWrap) priceWrap.outerHTML = buildPriceHtml(variant.price, variant.compare_price);
        }

        updateFbtSummary();
      });
    }

    /* Wire up add-to-basket */
    var bundleBtn = container.querySelector('[data-pq-bundle-btn]');
    if (bundleBtn) bundleBtn.addEventListener('click', handleBundleAdd);

    updateFbtSummary();

    /* Also-like section: next 3 plants after the results */
    renderAlsoLike();
  }

  function buildPriceHtml(price, comparePrice) {
    var p = (price / 100).toFixed(2);
    if (comparePrice && comparePrice > price) {
      var cp = (comparePrice / 100).toFixed(2);
      return '<div class="pq-fbt__price">' +
        '<span class="pq-fbt__price-current pq-fbt__price-current--sale">£' + p + '</span>' +
        '<span class="pq-fbt__price-compare">£' + cp + '</span>' +
        '</div>';
    }
    return '<div class="pq-fbt__price">' +
      '<span class="pq-fbt__price-current">£' + p + '</span>' +
      '</div>';
  }

  function buildMatchBreakdown(plant) {
    var m = plant._match;
    if (!m) return '';
    var items = [];

    /* Light */
    if (m.light === 'exact') {
      items.push('<li class="pq-match__item pq-match__item--yes">Light level</li>');
    } else {
      items.push('<li class="pq-match__item pq-match__item--close">Similar light</li>');
    }

    /* Pets */
    if (m.petSafe === 'yes') {
      items.push('<li class="pq-match__item pq-match__item--yes">Pet safe</li>');
    } else if (m.petSafe === 'not_required') {
      /* Don't show pet line if user said no pets */
    } else {
      items.push('<li class="pq-match__item pq-match__item--no">Not pet safe</li>');
    }

    /* Care */
    if (m.care === 'exact') {
      items.push('<li class="pq-match__item pq-match__item--yes">Care level</li>');
    } else if (m.care === 'close') {
      items.push('<li class="pq-match__item pq-match__item--close">Similar care level</li>');
    } else if (m.care === 'any') {
      items.push('<li class="pq-match__item pq-match__item--yes">Any care level</li>');
    } else {
      items.push('<li class="pq-match__item pq-match__item--no">Different care level</li>');
    }

    /* Size */
    if (m.size) {
      items.push('<li class="pq-match__item pq-match__item--yes">Size in stock</li>');
    } else {
      items.push('<li class="pq-match__item pq-match__item--no">Preferred size unavailable</li>');
    }

    return '<ul class="pq-match">' + items.join('') + '</ul>';
  }

  function buildAutoWhyText(plant, answers, isGift) {
    var light = answers.q1 || '';
    var experience = answers.q3 || 'beginner';
    var prefix = isGift ? 'Great for' : 'You mentioned';

    if (experience === 'beginner' && plant.care_difficulty === 'beginner') {
      return (isGift ? 'Perfect for a beginner — ' : 'You said you\'re starting out — ') +
        'this one is low-maintenance and forgiving.';
    }
    if (plant.light === 'low') {
      return prefix + (isGift ? ' low light spaces — ' : ' low light — ') +
        'this plant thrives without direct sun.';
    }
    return (isGift ? 'A great match for their space.' : 'A great match for your space.');
  }

  function renderEmptyState(container) {
    container.innerHTML =
      '<div class="pq-empty">' +
        '<p class="pq-empty__icon" aria-hidden="true">🌱</p>' +
        '<h3 class="pq-empty__title">No exact matches found</h3>' +
        '<p class="pq-empty__text">We couldn\'t find a perfect match for your answers, but our full collection might have something you\'ll love.</p>' +
        '<a href="/collections/all" class="pq-btn pq-btn--primary">Browse all plants</a>' +
      '</div>';
    /* Hide bundle CTA */
    var bundleWrap = $('[data-pq-bundle]');
    if (bundleWrap) bundleWrap.style.display = 'none';
  }

  function renderAlsoLike() {
    var container = $('[data-pq-also-like]');
    if (!container) return;

    /* Get plants not in results, score them */
    var light = LIGHT_MAP[state.answers.q1] || 'medium';
    var petSafe = state.answers.q2 === 'true';
    var experience = state.answers.q3 || 'beginner';
    var sizePreference = state.answers.q4 || 'medium';

    var resultHandles = state.results.map(function (r) { return r.handle; });
    var others = plants.filter(function (p) {
      return resultHandles.indexOf(p.handle) === -1;
    }).map(function (p) { return Object.assign({}, p); });

    others.forEach(function (p) { scorePlant(p, light, petSafe, experience, sizePreference); });
    others.sort(function (a, b) { return b._score - a._score; });
    others = others.slice(0, 3);

    if (others.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';
    var list = $('[data-pq-also-like-grid]', container);
    if (!list) return;
    list.innerHTML = '';

    others.forEach(function (plant, idx) {
      var commonName = plant.common_name || '';
      var botanicalName = plant.title;
      var displayPrice = (plant.price / 100).toFixed(2);
      var matchPills = buildMatchBreakdown(plant);

      /* Size pills */
      var sizePills = '';
      if (plant.variants && plant.variants.length >= 1) {
        sizePills = '<div class="pq-fbt__sizes">';
        plant.variants.forEach(function (vr) {
          sizePills += '<span class="pq-fbt__size-pill is-active">' + escapeHtml(vr.label) + '</span>';
        });
        sizePills += '</div>';
      }

      var item = document.createElement('div');
      item.className = 'pq-also-like__card';
      item.innerHTML =
        '<div class="pq-also-like__image-wrap">' +
          '<img src="' + escapeAttr(plant.image) + '" alt="' + escapeAttr(commonName || botanicalName) + '" loading="lazy" width="400" height="400">' +
        '</div>' +
        '<div class="pq-also-like__info">' +
          (commonName ? '<p class="pq-also-like__common">' + escapeHtml(commonName) + '</p>' : '') +
          '<h4 class="pq-also-like__name">' + escapeHtml(botanicalName) + '</h4>' +
          sizePills +
          matchPills +
          '<span class="pq-also-like__price">£' + displayPrice + '</span>' +
          '<button type="button" class="pq-also-like__cta" data-pq-add-to-bundle="' + idx + '">Add to bundle</button>' +
        '</div>';

      /* Store plant data on the element for the add handler */
      item._plantData = plant;
      list.appendChild(item);
    });

    /* Wire up "Add to bundle" buttons */
    var addBtns = list.querySelectorAll('[data-pq-add-to-bundle]');
    for (var ab = 0; ab < addBtns.length; ab++) {
      addBtns[ab].addEventListener('click', function (e) {
        e.stopPropagation();
        var card = this.closest('.pq-also-like__card');
        if (!card || !card._plantData) return;
        var plant = card._plantData;

        /* Pick best variant for quiz size */
        var defaultVariant = null;
        if (plant.variants && plant.variants.length) {
          for (var v = 0; v < plant.variants.length; v++) {
            if (plant.variants[v].bucket === sizePreference) { defaultVariant = plant.variants[v]; break; }
          }
          if (!defaultVariant) defaultVariant = plant.variants[0];
          plant._selectedVariant = defaultVariant;
        }

        /* Add to results and re-render */
        plant._selected = true;
        state.results.push(plant);
        renderResults();
      });
    }
  }

  /* ---------------------------------------------------------------
     BUNDLE CTA (Add all to cart)
  --------------------------------------------------------------- */
  function updateFbtSummary() {
    var totalEl = $('[data-pq-fbt-total]');
    var savingsEl = $('[data-pq-fbt-savings]');
    var btn = $('[data-pq-bundle-btn]');
    if (!totalEl) return;

    var total = 0;
    var compareTotal = 0;
    var selectedCount = 0;
    state.results.forEach(function (p) {
      if (p._selected) {
        var vr = p._selectedVariant;
        var vPrice = vr ? vr.price : p.price;
        var vCompare = vr ? vr.compare_price : p.compare_price;
        total += vPrice;
        compareTotal += (vCompare && vCompare > vPrice) ? vCompare : vPrice;
        selectedCount++;
      }
    });

    totalEl.innerHTML = '£' + (total / 100).toFixed(2);
    if (compareTotal > total) {
      totalEl.innerHTML += ' <span class="pq-fbt__summary-compare">£' + (compareTotal / 100).toFixed(2) + '</span>';
      savingsEl.textContent = 'You save £' + ((compareTotal - total) / 100).toFixed(2);
      savingsEl.style.display = '';
    } else {
      savingsEl.style.display = 'none';
    }

    if (btn) {
      btn.disabled = selectedCount === 0;
      if (selectedCount === 0) btn.textContent = 'Select at least one plant';
      else if (selectedCount === 1) btn.textContent = 'Add to basket';
      else btn.textContent = 'Add all ' + selectedCount + ' to basket';
    }
  }

  function handleBundleAdd() {
    var btn = $('[data-pq-bundle-btn]');
    var status = $('[data-pq-bundle-status]');
    if (!btn) return;

    var selected = state.results.filter(function (p) { return p._selected; });
    if (selected.length === 0) return;

    btn.disabled = true;
    btn.textContent = 'Adding to basket\u2026';
    track('quiz_bundle_clicked', { count: selected.length });

    var items = selected.map(function (p) {
      var vid = p._selectedVariant ? p._selectedVariant.id : p.first_variant_id;
      return { id: vid, quantity: 1 };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (res.ok) {
        btn.textContent = 'Added to basket!';
        if (status) {
          status.innerHTML = '<a href="/cart">View basket →</a>';
          status.style.display = '';
        }
        track('quiz_bundle_added', { count: items.length });
      } else {
        /* Atomic batch failed — retry individually */
        return retryIndividual(items, btn, status);
      }
    })
    .catch(function () {
      btn.textContent = 'Couldn\'t add to basket — try again';
      btn.disabled = false;
    });
  }

  function retryIndividual(items, btn, status) {
    var added = [];
    var failed = [];
    /* Sequential retries to avoid Shopify rate limiting */
    var chain = items.reduce(function (promise, item) {
      return promise.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        .then(function (res) {
          if (res.ok) { added.push(item.id); }
          else { failed.push(item.id); }
        })
        .catch(function () { failed.push(item.id); });
      });
    }, Promise.resolve());

    return chain.then(function () {
      if (failed.length === 0) {
        btn.textContent = 'Added to basket!';
        if (status) {
          status.innerHTML = '<a href="/cart">View basket →</a>';
          status.style.display = '';
        }
        track('quiz_bundle_added', { count: added.length });
      } else if (added.length > 0) {
        var soldOut = failed.map(function (id) {
          var p = state.results.find(function (r) {
            if (r.first_variant_id === id) return true;
            if (r.variants) {
              for (var s = 0; s < r.variants.length; s++) { if (r.variants[s].id === id) return true; }
            }
            return false;
          });
          return p ? (p.common_name || p.title) : 'a plant';
        });
        btn.textContent = added.length + ' of ' + items.length + ' added';
        if (status) {
          status.innerHTML = soldOut.join(', ') + ' sold out · <a href="/cart">View cart →</a>';
          status.style.display = '';
        }
        track('quiz_bundle_partial', { added: added.length, sold_out: soldOut });
      } else {
        btn.textContent = 'Couldn\'t add to basket — try again';
        btn.disabled = false;
      }
    });
  }

  /* ---------------------------------------------------------------
     GIFT MODE COPY
  --------------------------------------------------------------- */
  function applyGiftCopy() {
    setTextIf('[data-pq-q1-title]', GIFT_COPY.q1_title);
    setTextIf('[data-pq-q2-title]', GIFT_COPY.q2_title);
    setTextIf('[data-pq-q3-title]', GIFT_COPY.q3_title);
    setTextIf('[data-pq-q4-title]', GIFT_COPY.q4_title);
    setTextIf('[data-pq-email-title]', GIFT_COPY.email_heading);
    setTextIf('[data-pq-results-title]', GIFT_COPY.results_heading);
  }

  function resetGiftCopy() {
    setTextIf('[data-pq-q1-title]', NORMAL_COPY.q1_title);
    setTextIf('[data-pq-q2-title]', NORMAL_COPY.q2_title);
    setTextIf('[data-pq-q3-title]', NORMAL_COPY.q3_title);
    setTextIf('[data-pq-q4-title]', NORMAL_COPY.q4_title);
    setTextIf('[data-pq-email-title]', NORMAL_COPY.email_heading);
    setTextIf('[data-pq-results-title]', NORMAL_COPY.results_heading);
  }

  function setTextIf(sel, text) {
    var el = $(sel);
    if (el && text) el.textContent = text;
  }

  /* ---------------------------------------------------------------
     KLAVIYO INTEGRATION
  --------------------------------------------------------------- */
  function klaviyoIdentify(email, consent) {
    try {
      /* Newer Klaviyo onsite SDK — single identify call */
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        var profile = { email: email };
        if (state.giftMode) profile.quiz_gift_buyer = true;
        if (consent) profile.$consent = ['email'];
        window.klaviyo.identify(profile);
        return;
      }
      /* Legacy _klOnsite */
      if (window._klOnsite) {
        window._klOnsite.push(['identify', { $email: email }]);
        return;
      }
    } catch (e) {
      console.warn('PQ: Klaviyo identify failed', e);
    }
  }

  function klaviyoTrack(eventName, props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(eventName, props);
        return;
      }
      if (window._klOnsite) {
        window._klOnsite.push(['track', eventName, props]);
        return;
      }
    } catch (e) {
      console.warn('PQ: Klaviyo track failed', e);
    }
  }

  function buildKlaviyoProps() {
    var props = {
      quiz_light_level: state.answers.q1 || '',
      quiz_pet_safe: state.answers.q2 || '',
      quiz_experience: state.answers.q3 || '',
      quiz_size: state.answers.q4 || '',
      quiz_gift_mode: state.giftMode,
      quiz_result_count: state.results.length
    };
    state.results.forEach(function (p, i) {
      props['quiz_match_' + (i + 1)] = p.handle;
    });
    return props;
  }

  /* ---------------------------------------------------------------
     ABANDON RECOVERY
  --------------------------------------------------------------- */
  function setupAbandonRecovery() {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && state.emailCaptured && state.step !== 'results') {
        klaviyoTrack('quiz_abandoned', buildKlaviyoProps());
      }
    });
  }

  /* ---------------------------------------------------------------
     ANALYTICS (generic dataLayer / custom event)
  --------------------------------------------------------------- */
  function track(eventName, props) {
    try {
      /* Fire custom DOM event for any listener */
      root.dispatchEvent(new CustomEvent('pq:' + eventName, { detail: props || {} }));
    } catch (e) { /* old browsers */ }
  }

  /* ---------------------------------------------------------------
     HELPERS
  --------------------------------------------------------------- */
  function escapeHtml(s) {
    if (!s) return '';
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    if (!s) return '';
    return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ---------------------------------------------------------------
     BOOT
  --------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
